import { SourcedMap } from './create-sourced-map';
import { createState, State } from './create-state';

export type StateMap<TValues extends Record<string, unknown>> = {
	[TKey in keyof TValues]: State<TValues[TKey]>;
};

export const createStateMap = <TValues extends Record<string, unknown>>(
	values: SourcedMap<TValues>,
): StateMap<TValues> => {
	const states = Object.keys(values).reduce(
		(acc, key) => ({
			...acc,
			[key]: createState(values[key]),
		}),
		{} as StateMap<TValues>,
	);

	return states;
};
